import "./Contact.css";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaWhatsapp
} from "react-icons/fa";

function Contact() {
  return (
    <section className="contact" id="contact">

      <div className="container">

        <div className="section-title">

          <h2>Let's Build Something Great Together</h2>

          <p>
            We'd love to hear about your project. Get in touch with our team.
          </p>

        </div>

        <div className="contact-wrapper">

          <div className="contact-info">

            <div className="info-card">
              <FaPhoneAlt />
              <div>
                <h4>Call Us</h4>
                <p>+91 7722000088</p>
              </div>
            </div>

            <div className="info-card">
              <FaWhatsapp />
              <div>
                <h4>WhatsApp</h4>
                <p>+91 7722000088</p>
              </div>
            </div>

            <div className="info-card">
              <FaEnvelope />
              <div>
                <h4>Email</h4>
                <p>info@potech.in</p>
              </div>
            </div>

            <div className="info-card">
              <FaMapMarkerAlt />
              <div>
                <h4>Office</h4>
                <p>Near Z P School, Jamb Bk, Tq. Jintur Dist.Parbhani, Maharashtra, India</p>
              </div>
            </div>

          </div>

          <form className="contact-form">

            <input
              type="text"
              placeholder="Your Name"
            />

            <input
              type="email"
              placeholder="Email Address"
            />

            <input
              type="tel"
              placeholder="Mobile Number"
            />

            <input
              type="text"
              placeholder="Subject"
            />

            <textarea
              rows="6"
              placeholder="Tell us about your project..."
            ></textarea>

            <button type="submit">

              Send Message

            </button>

          </form>

        </div>

      </div>

    </section>
  );
}

export default Contact;